import {
  IMPORT_COMPRESSORS_IN_PROGRESS,
  IMPORT_COMPRESSORS_SUCCESS,
  IMPORT_COMPRESSORS_FAIL,
} from "../constants";

const initialState = {
  error: undefined,
  success: null,
  tsvReport: null,
};

/**
 * Import compressors reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function importCompressors(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case IMPORT_COMPRESSORS_IN_PROGRESS:
      return {
        ...initialState,
      };

    case IMPORT_COMPRESSORS_SUCCESS:
      return {
        ...state,
        success: true,
        error: null,
        tsvReport: payload.tsvReport,
      };

    case IMPORT_COMPRESSORS_FAIL:
      return {
        ...state,
        success: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
